import React from 'react';
import propTypes from 'prop-types';

import { Checkbox } from '@motorway/motorway-storybook-cra';

import { applyCypressData } from 'Utilities/helpers';
import proPropTypes from 'Utilities/proPropTypes';

const CheckBox = ({ checked, className, id, onChange, text, theme }) => (
	<Checkbox
		fullWidth
		className={className}
		inputProps={{
			id,
			input: {
				checked,
				...applyCypressData(`${id}Input`),
				name: id,
				onChange,
			},
		}}
		theme={theme}
	>
		{text}
	</Checkbox>
);

CheckBox.defaultProps = {
	checked: false,
	className: null,
	theme: 'dark',
};

CheckBox.propTypes = {
	checked: propTypes.bool,
	className: proPropTypes.className,
	id: propTypes.string.isRequired,
	onChange: propTypes.func.isRequired,
	text: propTypes.string.isRequired,
	theme: propTypes.oneOf(['light', 'dark']),
};

export default CheckBox;
